import type { ISocialLink } from './interfaces'
import type { ITabsItems } from '~/ts/interfaces/Tabs'

export const socialLinks: ISocialLink[] = [
    {
        id: 'social-3',
        img: 'https://api.plus.pl/file/images_lp/plus_acse_landingpages/Footer/socials/Social-Facebook.svg',
        alt: 'facebook',
        link: 'https://www.facebook.com/plus',
    },
    {
        id: 'social-2',
        img: 'https://api.plus.pl/file/images_lp/plus_acse_landingpages/Footer/socials/Social-YouTube.svg',
        alt: 'youtube',
        link: 'https://www.youtube.com/user/PLUSPL',
    },
    {
        id: 'social-4',
        img: 'https://api.plus.pl/file/images_lp/plus_acse_landingpages/Footer/socials/Social-Instagram.svg',
        alt: 'instagram',
        link: 'https://www.instagram.com/plus_polska/',
    },
    {
        id: 'social-1',
        img: 'https://api.plus.pl/file/images_lp/plus_acse_landingpages/Footer/socials/Social-X-Twitter.svg',
        alt: 'X',
        link: 'https://twitter.com/Plus_Polska?lang=pl',
    },
]

export const tabNames = ref<ITabsItems[]>([
    {
        id: 'abo',
        name: 'Abonament <br class="hidden xl:block"/>i sprzęt',
    },
    {
        id: 'internet',
        name: 'Internet',
    },
    {
        id: 'umowa',
        name: 'Przedłuż lub <br class="hidden xl:block"/> zmień umowę',
    },
])

export const additionalMailFields = {
    Internet: {
        SFID: '29200200',
        BAZA_SALES: 'BAZY_ZEWNETRZNE_LEADY_DATA',
        ZDARZENIE: 'Lead_WWW_Pozyskanie_TMZ_Liberty1',
        TYP: 'POZYSKANIE',
        OPIS: 'STOPKA_internet',
        SOW: 'TAK',
    },
    Abonament: {
        SFID: '30000235',
        BAZA_SALES: 'BAZY_ZEWNETRZNE_LEADY_WWW_10',
        ZDARZENIE: 'LEADY_WWW_STOPKA_2',
        TYP: 'POZYSKANIE',
        OPIS: 'STOPKA_abo_sprzet',
        SOW: 'TAK',
    },
    Sprzet: {
        SFID: '29200200',
        BAZA_SALES: 'RET_LEADY_WWW_10',
        ZDARZENIE: 'RET_LEADY_STOPKA_2',
        TYP: 'ZATRZYMANIE',
        OPIS: 'STOPKA_przedluz',
        SOW: 'TAK',
    },
}

export const sohoAdditionalMailFields = {
    Internet: {
        SFID: '29200200',
        BAZA_SALES: 'BAZY_ZEWNETRZNE_LEADY_DATA',
        ZDARZENIE: 'Lead_WWW_Pozyskanie_TMZ_Liberty1',
        TYP: 'POZYSKANIE',
        OPIS: 'STOPKA_internet_SOHO',
        SOW: 'TAK',
    },
    Abonament: {
        SFID: '30000235',
        BAZA_SALES: 'BAZY_ZEWNETRZNE_LEADY_WWW_10',
        ZDARZENIE: 'LEADY_WWW_STOPKA_2',
        TYP: 'POZYSKANIE',
        OPIS: 'STOPKA_abo_sprzet_SOHO',
        SOW: 'TAK',
    },
    Sprzet: {
        SFID: '29200200',
        BAZA_SALES: 'RET_LEADY_WWW_10',
        ZDARZENIE: 'RET_LEADY_STOPKA_2',
        TYP: 'ZATRZYMANIE',
        OPIS: 'STOPKA_przedluz_SOHO',
        SOW: 'TAK',
    },
}

export const successFormMessage = {
    title: 'Dziękujemy za wysłanie numeru',
    subtitle: 'Nasz konsultant skontaktuje się z Tobą, by dopasować ofertę do Twoich potrzeb',
}

export const warningFormMessage = {
    title: 'Ups! Coś poszło nie tak',
    subtitle:
        'Przepraszamy, nie udało nam się wysłać Twojego zgłoszenia. Prawdopodobnie to chwilowy problem techniczny. Prosimy spróbować ponownie.',
}

export const formData = {
    title: 'Wolisz porozmawiać <br />z konsultantem?',
    subtitle: 'Zostaw numer, jeśli jesteś zainteresowany ofertą',
    text: 'Chcesz porozmawiać o zasięgu, płatnościach lub usługach dodatkowych? Zadzwoń do Działu Obsługi Klienta:',
    phoneNumber: '+48 601 100 601',
    infoText: '',
    infoSubtext: '* Koszt połączenia jest zgodny z taryfą operatora',
    appText: 'Pobierz aplikację <br/> i obsługuj swoje konto',
}

export const checkboxes = ref([
    {
        checkboxNumber: 1,
        id: 'checked1',
        label: 'Wyrażam zgodę na przetwarzanie przez Polkomtel sp. z o.o. moich danych osobowych wskazanych w niniejszym formularzu w celach sprzedaży i marketingu bezpośredniego własnych produktów i usług.',
        error: 'To pole jest wymagane',
        gaEventText: 'zgoda na przetwarzanie danych osobowych',
    },
    {
        checkboxNumber: 2,
        id: 'checked2',
        label: 'Wyrażam zgodę na otrzymywanie, przesłanych przez Polkomtel Sp. z o.o., informacji handlowych, w tym na marketing bezpośredni przy użyciu automatycznych systemów wywołujących lub telekomunikacyjnych urządzeń końcowych, w szczególności w ramach korzystania z usług komunikacji interpersonalnej, z wykorzystaniem telefonu, SMS, MMS.',
        error: 'To pole jest wymagane',
        gaEventText: 'zgoda na otrzymywanie informacji handlowych',
    },
])

export const inputLabel = 'Telefon kontaktowy'

export const secondInputLabel = 'Numer telefonu, którego dotyczy przedłużenie umowy'
